import endpoints from "@/api/endpoints";
import httpClient from "@/api/http-client";
import { Product } from "@/models/product";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";
import { AppState } from "..";

export interface ProductState {
  data: Product | null;
  selectedPrice: Product["prices"][0] | null;
  related: any;
  location: any;
}

const initialState: ProductState = {
  data: null,
  selectedPrice: null,
  related: [],
  location: null,
};

export const fetchLocation = createAsyncThunk(
  "product/fetchLocation",
  async (params: any = {}) => {
    const { data } = await httpClient.post(endpoints.products.storeLocation(), {
      slug: params.slug,
      pincode: params.pincode,
      size: params.size || "",
    });
    return data;
  }
);

export const fetchProductBySlug = createAsyncThunk(
  "product/fetchProductBySlug", // Fixed action type to match slice name
  async (slug: string) => {
    const { data } = await httpClient.get(endpoints.products.product(slug));
    return data;
  }
);

export const fetchRelatedProductBySlug = createAsyncThunk(
  "product/fetchRelatedProductBySlug", // Fixed action type to match slice name
  async (slug: string) => {
    const { data } = await httpClient.get(endpoints.products.related(slug));
    return data;
  }
);

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setProduct: (state, action: PayloadAction<ProductState["data"]>) => {
      state.data = action.payload;
    },
    setSelectedPrice: (
      state,
      action: PayloadAction<ProductState["selectedPrice"]>
    ) => {
      state.selectedPrice = action.payload;
    },
    setLocation: (state, action: PayloadAction<ProductState["location"]>) => {
      state.location = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(HYDRATE, (state, action: any) => {
        if (action.payload.product.data) {
          state.data = action.payload.product.data;
          state.selectedPrice = action.payload.product.selectedPrice;
        }
        if (action.payload.product.location) {
          state.location = action.payload.product.location;
        }
      })
      .addCase(fetchLocation.fulfilled, (state, action) => {
        state.location = action.payload;
      })
      .addCase(fetchProductBySlug.fulfilled, (state, action) => {
        state.data = action.payload;
        state.selectedPrice = action.payload.prices.find(
          (v: any) => v.id == action.payload.defaultPriceId
        );
      })
      .addCase(fetchRelatedProductBySlug.fulfilled, (state, action) => {
        state.related = action.payload;
      });
  },
});

export const { setProduct, setSelectedPrice, setLocation } =
  productSlice.actions;

export const selectProduct = (state: AppState) => state.product;

export default productSlice.reducer;
